import React from "react"
import { css } from "@emotion/core"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import HomepageList from "../components/homepage_list"
import SubscribeForm from "../components/subscribe_form"
import Helmet from "react-helmet"

import { rhythm } from "../utils/typography"

const CATEGORIES = [
  "Initial Formation",
  "Building Product",
  "Day-To-Day Operations",
  "Understanding Your Users",
]

function getArticleCards(edges) {
  let homepageLists = CATEGORIES.map(function(category) {
    return (
      <div>
        <HomepageList
          props={{
            category: category,
            nodes: edges.filter(function(node) {
              return node.node.frontmatter.category == category
            }),
          }}
        />
      </div>
    )
  })

  homepageLists.splice(1, 0, <SubscribeForm></SubscribeForm>)

  return (
    <div
      css={css`
        column-count: 2;
        column-gap: 30px;

        > div {
          -webkit-column-break-inside: avoid;
          -moz-column-break-inside: avoid;
          -o-column-break-inside: avoid;
          -ms-column-break-inside: avoid;
          column-break-inside: avoid;

          margin-bottom: 40px;
        }

        @media only screen and (max-width: 576px) {
          column-count: 1;
        }
      `}
    >
      {homepageLists}
    </div>
  )
}

export default ({ data }) => {
  return (
    <Layout>
      <Helmet>
        <meta
          name="description"
          content="At Satchel, we identify the best-of-category tool for a typical early-stage startup based on rigorous, hands-on testing and standardized assessments."
        />
      </Helmet>
      <div
        css={css`
          max-width: 1040px;
          padding: 0 20px;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 60px;

          // display: flex;
          // flex-direction: column;
        `}
      >
        <div
          css={css`
            margin-top: 50px;
            margin-bottom: 70px;

            margin-left: auto;
            margin-right: auto;

            max-width: 720px;
            font-size: 17px;
          `}
        >
          <div
            css={css`
              font-size: 32px;
              margin-bottom: 18px;
            `}
          >
            Make more informed decisions about SaaS.
          </div>
          <div
            css={css`
              margin-bottom: 12px;
            `}
          >
            Satchel Guides is an initiative from Satchel to help early-stage
            startups by writing guides to SaaS. We try to identify the
            best-of-category tool for a typical early-stage startup based on
            rigorous, hands-on testing and standardized assessments. Along the
            way, we uncover and share info that should be obvious (but isn't),
            and point out any caveats and pitfalls you might encounter.{" "}
          </div>
          <div>
            Our priority is to remain unbiased and reliable. We have no
            financial relationship with any of the products that we write about.
            We operate free of influence from any external organization or
            company.{" "}
            <Link
              to={`/about`}
              css={css`
                font-weight: 700;
                font-size: 15px;
                text-decoration: none;
                border-bottom: 2px solid #473dc7;
                color: #473dc7;
              `}
            >
              Learn More
            </Link>
          </div>
        </div>
        {getArticleCards(data.allMdx.edges)}

        <div
          css={css`
            margin-top: 60px;
            margin-bottom: 0;

            background-color: #f3f3f3;
            border-radius: 3px;
          `}
        >
          <div
            css={css`
              margin-left: auto;
              margin-right: auto;
              // max-width: 720px;

              padding: 25px 20px;
            `}
          >
            <div
              css={css`
                font-size: 19px;
                font-weight: 500;
                margin-bottom: 12px;

                text-align: center;
              `}
            >
              We're hard at work testing and writing more guides.
            </div>
            <div
              css={css`
                font-size: 15px;
                margin-bottom: 20px;
                color: #777;

                text-align: center;
              `}
            >
              Some upcoming topics in the works:
            </div>
            <div
              css={css`
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-auto-rows: 1fr;
                grid-row-gap: 10px;
                grid-column-gap: 10px;

                margin-bottom: 30px;

                @media only screen and (max-width: 900px) {
                  grid-template-columns: 1fr 1fr;
                  grid-auto-rows: auto;
                  grid-template-rows: 1fr;

                @media only screen and (max-width: 576px) {
                  grid-template-columns: 1fr;
                  grid-auto-rows: auto;
                  grid-template-rows: 1fr;
                }
              `}
            >
              <UpcomingCard category="Startup Bookkeeping / Tax Services">
                Startup bookkeeping services are unique in that they utilize a
                number of human-in-the-loop processes. This means that founder
                experiences are much more variable. We'll be doing a longer-term
                test of startup bookkeeping services (e.g. Bench, Pilot,
                InDinero), and reconcile our results with other founders'
                experiences.
              </UpcomingCard>
              <UpcomingCard category="ETL">
                Stitch and Fivetran are two main standalone players in the
                landscape of ETL tools, although there are also a scattering of
                other ETL tools out there. We'll be delving into them to
                evaluate differences and tradeoffs. This is a bit more of a
                mature-company-topic than our typical early-stage startup focus.
              </UpcomingCard>
              <UpcomingCard category="Static Site Hosting">
                If you have a static (or mostly static/JAMstack) site, how have
                your options for hosting evolved? Netlify and Vercel (formerly
                Zeit) have both just raised large rounds and have staunch
                supporters, but what is the improvement over Heroku, Surge.sh,
                or the reliable (and free) Github Pages?
              </UpcomingCard>
              <UpcomingCard category="Continuous Integration">
                What are the differences (if any) among the standalone CI/CD
                tools like CircleCI, TravisCI, and Jenkins? How do they compare
                against integrated CI tools like Heroku CI, GitLab CI, and
                Github Actions? Are they worth the extra work, or is integrated
                CI sufficient for a typical early-stage startup?
              </UpcomingCard>
              <UpcomingCard category="Payment Processors" preliminary="">
                Conventional wisdom is that Stripe has the best dev experience,
                which is particularly important for young startups. But with the
                main competition (Braintree, Adyen, Checkout.com et al.)
                starting to reach feature parity, we're taking a look to see how
                conventional wisdom holds 10 years out.
              </UpcomingCard>
              <UpcomingCard category="Remote Work Communication">
                We're not particularly focused on evaluating the best
                videoconferencing tool (we think that Zoom is a good,
                well-scrutinized default). We're more intent on figuring out if
                more omnipresent remote tools (e.g. Tandem) are better suited
                for the "around-the-table" communication needs of an early-stage
                startup.
              </UpcomingCard>
            </div>
            <div
              css={css`
                max-width: 650px;
                margin: 0 auto;
                text-align: center;
                font-weight: 500;
                color: #000;
                background-color: #e0ddf6;
                padding: 12px 20px;
                border-radius: 3px;
                border: 1px solid #473dc7;

                @media only screen and (max-width: 576px) {
                  text-align: left;
                }
              `}
            >
              If you want to suggest a topic for us to dig into, or hear our
              preliminary findings & recommendations for any of these
              in-progress guides, you can <a href="/contact">drop us a line</a>.
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

const UpcomingCard = ({ category, preliminary, children }) => (
  <div
    css={css`
      padding: 8px 12px;
      background-color: #fff;
      border: 1px solid #f8f8f8;
      box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05);
      border-radius: 3px;
    `}
  >
    <div
      css={css`
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 8px;
      `}
    >
      {category}
    </div>
    <div
      css={css`
        font-size: 15px;
      `}
    >
      {children}
    </div>
  </div>
)

export const query = graphql`
  query {
    allMdx(
      filter: { frontmatter: { type: { eq: "guide" } } }
      sort: { fields: [frontmatter___order], order: ASC }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            description
            order
            image
            type
            in_progress
            stub
            category
            recommendation
            homepage_title
            short_description
          }
          timeToRead
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`
